export default __webpack_public_path__ + "static/media/gaje_predictor.6a530dbf.png";